'use client';

import React from 'react';
import Section from '@/app/components/Section';
import CampaignDynamicSection from '@/app/components/Section/CampaignDynamicSection';

function HomeClientPage({ sections = [] }) {
  return (
    <div className="min-h-screen lg:mb-[104px] mb-[70px]">
      {sections?.map((section, index) => {
        if (section?.is_group_section && Array.isArray(section?.sub_sections)) {
          return (
            <CampaignDynamicSection
              key={section?.id ?? index}
              section={section}
            />
          );
        }
        return <Section key={section?.id ?? index} section={section} />;
      })}
    </div>
  );
}

export default HomeClientPage;
